import { Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { PDIProvider } from './context/PDIContext';
import Layout from './components/Layout';
import GuidancePage from './pages/GuidancePage';
import ChecklistPage from './pages/ChecklistPage';
import SummaryPage from './pages/SummaryPage';
import CarProfilePage from './pages/CarProfilePage';
import LegalRightsPage from './pages/LegalRightsPage';
import SharedReportPage from './pages/SharedReportPage';

function App() {
  return (
    <PDIProvider>
      <Routes>
        {/* Public shared report — standalone, no app nav */}
        <Route path="/r/:id" element={<SharedReportPage />} />
        {/* The app */}
        <Route
          path="/*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<GuidancePage />} />
                <Route path="/checklist" element={<ChecklistPage />} />
                <Route path="/summary" element={<SummaryPage />} />
                <Route path="/car-profile" element={<CarProfilePage />} />
                <Route path="/legal" element={<LegalRightsPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
      <Analytics />
    </PDIProvider>
  );
}

export default App;
